const NETWORK_AVAILABILITY = {
  CEN: "cen",
  ALB: "alb",
  ECS: "ecs",
  NLB: "nlb",
  CLB: "clb",
  RDS_MYSQL: "rds-mysql",
  RDS_POSTGRESQL: "rds-postgresql",
  RDS_SQLSERVER: "rds-sqlserver",
  RDS_MARIADB: "rds-mariadb",
};

export { NETWORK_AVAILABILITY };
